<template>
  <div class="cart-box">
    <ul class="cart-list">
      <li
        v-for="(item, index) in cartInforCopy.list"
        :key="index"
        :class="[handleIsDisabled(item).disabled && 'gift-select']"
      >
        <div class="img-wrap" :class="{ 'is-glass': item?.product?.is_glass == 1 }">
          <FrameImage
            class="frame-img-wrap"
            :class="[item.product?.img_gray && !showFrameBg(item) && 'product-gray']"
            :productDetail="item.product"
            :lens="item.lens"
            :showGrayPic="true"
          />
        </div>
        <div class="cart-info">
          <div class="cart-info-top">
            <div class="name">
              <span class="name-word">{{ item.product.short_name }} </span>
              <cart-gift-label
                v-if="
                  (item?.type == 3 && item?.gift_type != 1) ||
                  item?.gift_type == 1 ||
                  valuationList[index]
                "
                :giftType="valuationList[index]?.gift_type"
                :productSaleType="valuationList[index]?.type"
                :item="item"
                :valuationItem="valuationList[index] || {}"
                :cartPrice="cartPrice"
              />
            </div>
            <div class="color">
              Color:<span>{{ item.product.color }}</span>
            </div>
            <div class="pres">
              <!-- 没有处方类型时留空，占位用 -->
              {{
                item.option.prescription_type && item.option.prescription_type != 'Frame Only'
                  ? item.option.prescription_type
                  : '&nbsp;'
              }}
            </div>
            <div class="qty-price-box">
              <div class="qty-price">
                Qty:<span>{{ item.qty }}</span>
              </div>
              <!-- 与wap端购物车逻辑一致，后续可优化此逻辑 -->
              <div class="goods-price-box">
                <template v-if="valuationList[index]">
                  <span
                    class="show-price notranslate"
                    :class="[
                      (item.gift_type == 1 ||
                        (item.gift_type != 1 && item.type == 3) ||
                        (valuationList[index] && valuationList[index].gift_type == 2) ||
                        +item.is_gift_buy_activity_product === 1 ||
                        (valuationList[index].half_qty &&
                          Number(valuationList[index].base_product_rule_discounts_price) > 0)) &&
                        ((getLineThroughIf(valuationList[index], item) &&
                          getShowIfPrice(valuationList[index], item) !=
                            getLineThroughIfPrice(valuationList[index], item)) ||
                          (getLineThroughElse(item) &&
                            getShowIfPrice(valuationList[index], item) !=
                              getLineThroughElsePrice(item))) &&
                        !item.lenseShow &&
                        'base-color',
                    ]"
                    v-if="
                      item.gift_type == 1 ||
                      (valuationList[index] && valuationList[index].gift_type == 2) ||
                      +item.is_gift_buy_activity_product === 1 ||
                      (valuationList[index].half_qty &&
                        Number(valuationList[index].base_product_rule_discounts_price) > 0)
                    "
                    >{{ currency.symbol_prefix
                    }}{{
                      Number(
                        Number(valuationList[index].product_payable) +
                          Number(valuationList[index].product_point_discounts_price) +
                          Number(valuationList[index].product_code_discounts_price) +
                          Number(totalClipPriceInfo(item.clips, currency.name).sell_price),
                      ).toFixed(2)
                    }}{{ currency.symbol_suffix }}
                  </span>
                  <span
                    v-else
                    class="show-price notranslate"
                    :class="[
                      (item.gift_type == 1 ||
                        (item.gift_type != 1 && item.type == 3) ||
                        (valuationList[index] && valuationList[index].gift_type == 2) ||
                        +item.is_gift_buy_activity_product === 1 ||
                        (valuationList[index].half_qty &&
                          Number(valuationList[index].base_product_rule_discounts_price) > 0)) &&
                        !item.lenseShow &&
                        'base-color',
                    ]"
                    >{{ currency.symbol_prefix
                    }}{{
                      (
                        Number(valuationList[index].product_payable) +
                        Number(valuationList[index].product_rule_discounts_price) +
                        Number(valuationList[index].product_point_discounts_price) +
                        Number(valuationList[index].product_code_discounts_price) +
                        Number(totalClipPriceInfo(item.clips, currency.name).sell_price)
                      ).toFixed(2)
                    }}{{ currency.symbol_suffix }}</span
                  >
                  <!-- 展示划线价 -->
                  <!-- 不是会员礼展示的划线价 -->
                  <!-- 第二件半价的划线价 生日礼 -->
                  <span
                    class="through-line-price notranslate"
                    v-if="
                      (((+item.is_gift_buy_activity_product === 1 ||
                        (valuationList[index].half_qty &&
                          Number(valuationList[index].base_product_rule_discounts_price) > 0) ||
                        (valuationList[index] && valuationList[index].gift_type == 2)) &&
                        +getShowIfPrice(valuationList[index], item) <
                          +getLineThroughIfPrice(valuationList[index], item)) ||
                        item.type == 3) &&
                      !item.lenseShow
                    "
                    >{{ currency.symbol_prefix
                    }}{{
                      valuationList[index].type == 3
                        ? Number(
                            Number(valuationList[index].discount_birthday) +
                              Number(valuationList[index].product_payable_no_half) +
                              Number(valuationList[index].product_promotion_price) +
                              Number(totalClipPriceInfo(item.clips, currency.name).sell_price),
                          ).toFixed(2)
                        : Number(
                            Number(valuationList[index].discount_birthday) +
                              Number(valuationList[index].product_payable_no_half) +
                              Number(totalClipPriceInfo(item.clips, currency.name).sell_price),
                          ).toFixed(2)
                    }}{{ currency.symbol_suffix }}
                  </span>
                </template>

                <template v-else>
                  <template v-if="item.type == 3">
                    <span class="show-price base-color">
                      {{ currency.symbol_prefix }}{{ $priceUtil.genItemPrice(item)
                      }}{{ currency.symbol_suffix }}
                    </span>
                    <span class="through-line-price"
                      >{{ currency.symbol_prefix
                      }}{{
                        (
                          Number($priceUtil.genPrice(item.product.price_info).price) +
                          Number(
                            geteachPrice(item.lens?.lens_id, item.lens?.price_info).sell_price,
                          ) +
                          Number(
                            geteachPrice(item.coating?.coating_id, item.coating?.price_info)
                              .sell_price,
                          ) +
                          Number(totalClipPriceInfo(item.clips, currency.name).sell_price)
                        ).toFixed(2)
                      }}{{ currency.symbol_suffix }}</span
                    >
                  </template>
                  <template v-else>
                    {{ currency.symbol_prefix }}{{ $priceUtil.genItemPrice(item)
                    }}{{ currency.symbol_suffix }}
                  </template>
                </template>
              </div>
            </div>
          </div>
          <!-- 赠品展示的提示、倒计时 -->
          <div
            v-if="
              (hasFreeGiftSelected && item.disabled) ||
              showFreeAddLense(item) ||
              (item.disabled &&
                selectedNoFreeGiftProductPrice <
                  Number($priceUtil.genPrice(item?.threshold_products_total_price).price).toFixed(
                    2,
                  )) ||
              (item.relationable?.end_time_count_down && countDownMap[item.cart_id]) ||
              item.relationable?.end_time_show
            "
            class="text-box"
          >
            <p class="text" key="1" v-if="hasFreeGiftSelected && item.disabled">
              Only one gift per order
            </p>
            <p class="text" key="2" v-else-if="showFreeAddLense(item)">
              Add lenses before checkout
            </p>
            <p
              class="text"
              key="3"
              v-else-if="
                item.disabled &&
                selectedNoFreeGiftProductPrice <
                  Number($priceUtil.genPrice(item?.threshold_products_total_price).price).toFixed(2)
              "
            >
              Buy over {{ currency.symbol_prefix
              }}{{
                Number($priceUtil.genPrice(item?.threshold_products_total_price).price).toFixed(2)
              }}
              {{ currency.symbol_suffix }} to get gifts
            </p>
            <!-- 赠品倒计时展示 -->
            <p
              v-if="item.relationable?.end_time_count_down && countDownMap[item.cart_id]"
              key="4"
              class="text"
            >
              Expires in: {{ formatCountDown(countDownMap[item.cart_id]) }}
            </p>
            <p v-else-if="item.relationable?.end_time_show" key="5" class="text">
              Valid Till: {{ item.relationable.end_time_show }}
            </p>
          </div>
        </div>
      </li>
    </ul>
    <div class="bottom-wrap">
      <div
        v-if="freePolicy && cartPrice.price.subtotal != 0 && !freeShippingStatus"
        class="deliver"
      >
        <p class="word-policy notranslate" v-html="freePolicy"></p>
      </div>
      <div class="bottom-price">
        <div v-show="showTotal" class="total-box">
          <p>
            <span>Total</span>
            <span :key="cartPrice.total" class="notranslate"
              >{{ currency.symbol_prefix }}{{ cartPrice.total }}{{ currency.symbol_suffix }}</span
            >
          </p>
          <p v-if="cartPrice.discount_birthday && cartPrice.discount_birthday != '0.00'">
            <span class="gray">Birthday Offer</span>
            <span :key="cartPrice.discount_birthday" class="notranslate special-off"
              >- {{ currency.symbol_prefix }}{{ cartPrice.discount_birthday
              }}{{ currency.symbol_suffix }}</span
            >
          </p>
          <p v-if="cartPrice?.price?.discounts_rule != '0.00'">
            <span class="gray">{{ cartPrice.price?.discount_rule_text }}</span>
            <span :key="cartPrice?.price?.discounts_rule" class="notranslate special-off"
              >- {{ currency.symbol_prefix }}{{ cartPrice?.price?.discounts_rule
              }}{{ currency.symbol_suffix }}</span
            >
          </p>
          <p v-if="Number(cartPrice.price?.code_discount) > 0">
            <span class="gray">Code / Coupon</span>
            <span :key="cartPrice.price?.code_discount" class="notranslate special-off"
              >- {{ currency.symbol_prefix }}{{ cartPrice.price?.code_discount
              }}{{ currency.symbol_suffix }}</span
            >
          </p>
          <p v-if="cartPrice.price?.is_point == 1">
            <span class="gray"
              >Points
              <i
                class="iconfont icon-bangzhu point-tip"
                @click="$refs.RefPointDialog.DialogShow = true"
              ></i>
            </span>
            <span :key="cartPrice.price?.point_discount" class="notranslate special-off"
              >- {{ currency.symbol_prefix }}{{ cartPrice.price?.point_discount
              }}{{ currency.symbol_suffix }}</span
            >
          </p>
        </div>
        <div class="subtotal-box">
          <span class="subtotal-name">Subtotal</span>
          <p>
            <span
              v-show="Number(cartPrice.price?.discount) > 0"
              class="all-saved"
              @click="showTotal = !showTotal"
            >
              Saved
              <span class="notranslate"
                >{{ currency.symbol_prefix }}{{ cartPrice.price?.discount
                }}{{ currency.symbol_suffix }}</span
              >
              <i class="iconfont icon-xiangyou-xi" :class="{ rotate: showTotal }"></i>
            </span>
            <span :key="cartPrice.price?.subtotal" class="notranslate special-money">
              {{ currency.symbol_prefix }}{{ cartPrice.price?.subtotal
              }}{{ currency.symbol_suffix }}
            </span>
          </p>
        </div>
        <div class="btn-box">
          <el-button type="default" class="view_my_cart" @click="toCart">View My Cart</el-button>
          <el-button type="primary" :loading="loading.check" @click="toPayment"
            >Proceed to Checkout</el-button
          >
        </div>
      </div>
    </div>
  </div>
  <PointDialog ref="RefPointDialog" />
</template>

<script>
import { setSession } from '@/assets/js/common';
import { genPrice } from '@/assets/js/currency-price';
import { useCountDown } from '@/composables/countDown';
import { useStore } from '@/store';
import {
  getCartIds,
  setClipValuation,
  totalClipPriceInfo,
} from '@/views/shopping-cart/modules/clip';
import { mapActions, mapState } from 'pinia';
import { defineAsyncComponent } from 'vue';
import { deepCopyNew as deepClone } from '~/assets/js/type';

export default {
  components: {
    FrameImage: defineAsyncComponent(() => import('@/views/module/FrameImage.vue')),
    PointDialog: defineAsyncComponent(() => import('@/views/checkout/modules/point-dialog.vue')),
    CartGiftLabel: defineAsyncComponent(
      () => import('@/views/my-account/modules/CartGiftLabel.vue'),
    ),
  },
  props: {
    toshowCart: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['update:toshowCart', 'visitorToPayment'],
  data() {
    return {
      cartPrice: {
        total: '0.00',
        discount: '0.00',
        subtotal: '0.00',
        price: {
          subtotal: '0.00',
          discount: '0.00',
          total: '0.00',
        },
      },
      valuationList: [], // 计价数据列表
      freePolicy: '',
      freeShippingStatus: false, // 新客首单免平邮活动包邮提示信息
      showTotal: false,
      loading: {
        check: false,
      },
      countDownMap: {}, // 存储每个购物车项的倒计时实例
      hasFreeGiftSelected: false,
    };
  },
  computed: {
    ...mapState(useStore, ['cartInfor', 'currency', 'token']),
    cartInforCopy() {
      const _cartInforCopy = deepClone(this.cartInfor);
      _cartInforCopy.list.forEach((item) => {
        item.selected = item.type !== 3;
      });
      return _cartInforCopy;
    },
    // 所有的购物车id
    checkIds() {
      try {
        return this.cartInforCopy.list.map((item) => item.cart_id);
      } catch (error) {
        console.log(error);
      }
      return [];
    },
    /// 获取当前选中的赠品不包含优惠券 优惠码 积分抵扣的价格
    selectedFreeGiftProductPrice() {
      let valuationItem = null;
      let selectedFreeGiftCart = null;

      selectedFreeGiftCart = this.cartInforCopy.list.find((element) => {
        return element.type == 3 && element.selected;
      });
      valuationItem = this.valuationList.find(
        (element) => element?.id == selectedFreeGiftCart?.cart_id,
      );

      let choosedGiftPrice = 0;
      if (valuationItem != null) {
        /// 积分优惠金额当前币种
        const productPointDiscountsPrice = Number(
          valuationItem?.product_point_discounts_price || '0.00',
        );

        /// 优惠码优惠金额当前币种
        const productCodeDiscountsPrice = Number(
          valuationItem?.product_code_discounts_price || '0.00',
        );
        choosedGiftPrice =
          Number(valuationItem?.product_payable || '0.00') +
          Number(valuationItem?.product_rule_discounts_price || '0.00') +
          productPointDiscountsPrice +
          productCodeDiscountsPrice;

        const model = Number(
          this.totalClipPriceInfo(selectedFreeGiftCart.clips, this.currency.name).sell_price,
        );

        choosedGiftPrice += model;
      }

      return choosedGiftPrice && Number(choosedGiftPrice.toFixed(2));
    },

    /// 获取当前选中的商品 （不包含赠品） 不包含优惠券 优惠码 积分抵扣的价格
    selectedNoFreeGiftProductPrice() {
      const price =
        Number(this.cartPrice.price?.subtotal || '0.00') +
        Number(this.cartPrice.price?.code_discount || '0.00') +
        Number(this.cartPrice.price?.point_discount || '0.00');

      return Number((price - this.selectedFreeGiftProductPrice).toFixed(2));
    },
  },
  watch: {
    checkIds: {
      handler(newVal) {
        if (this.$route.name == 'cart') return;
        this.getCartPrice();
      },
      deep: true,
    },
    $route(to, from) {
      // 因为购物页不再调用接口，为了数据正确，在离开购物车，获取数据
      if (from?.path === '/cart') {
        this.getCartPrice();
      }
    },
    toshowCart() {
      if (this.toshowCart) {
        this.showTotal = false;
      }
    },
    'cartInfor.list': {
      handler(newList) {
        // 清理不存在的倒计时实例
        const newIds = new Set(newList.map((item) => item.cart_id));
        Object.keys(this.countDownMap).forEach((cart_id) => {
          if (!newIds.has(Number(cart_id))) {
            // 停止并删除不存在的倒计时
            if (this.countDownMap[cart_id]?.stop) {
              this.countDownMap[cart_id].stop();
            }
            delete this.countDownMap[cart_id];
          }
        });

        // 为需要倒计时的项创建倒计时实例
        newList.forEach((item) => {
          if (item.relationable?.end_time_count_down) {
            // 如果已存在倒计时实例，先停止
            if (this.countDownMap[item.cart_id]?.stop) {
              this.countDownMap[item.cart_id].stop();
            }
            // 创建新的倒计时实例
            const seconds = ref(Number(item.relationable.end_time_count_down));
            this.countDownMap[item.cart_id] = useCountDown(seconds, () => {
              // 倒计时结束，暂时不刷新页面. 因为用户没有展示悬浮窗时突然刷新体验不好
              // if (process.client) {
              //   window.location.reload();
              // }
            });
          }
        });
      },
      immediate: true,
    },
  },
  mounted() {
    // 刷新当前页面时，如果是登陆状态，会在app.vue里调用一下购物车接口，会走watch里的逻辑，所以这里只用处理未登录状态
    if (
      !this.token &&
      this.cartInforCopy &&
      this.cartInforCopy.list &&
      this.cartInforCopy.list.length > 0
    ) {
      this.getCartPrice();
    }
  },
  unmounted() {
    // 清理所有倒计时实例
    Object.values(this.countDownMap).forEach((countDown) => {
      if (countDown?.stop) {
        countDown.stop();
      }
    });
    this.countDownMap = {};
  },
  methods: {
    ...mapActions(useStore, ['SET_CARTINFOR']),
    geteachPrice(id, arr) {
      if (id) {
        return genPrice(arr);
      }
      return {
        price: '',
        sell_price: '',
      };
    },
    // Details 按钮展示为 Add Lense，并且下面出提示
    showFreeAddLense(item) {
      return (
        item.type == 3 &&
        item.relationable?.optician_balance == 2 &&
        item.product?.is_glass == 1 &&
        item.product?.product_lens == 1 &&
        item.lens?.lens_id <= 1
      );
    },
    // 格式化倒计时显示
    formatCountDown(countDown) {
      if (!countDown) return '';
      const formatNum = (num) => (num > 9 ? num : `0${num}`);
      return `${formatNum(countDown.hr)}:${formatNum(countDown.min)}:${formatNum(countDown.sec)}`;
    },
    showFrameBg(item) {
      try {
        // 是否展示带背景色的镜框背景图和镜腿背景图
        if (item.lens?.color_no && item.lens.transparency && item.lens.transparency != 0) {
          if (item.product.frame_background_image && item.product.background_image_of_mirror_leg) {
            if (item.lens.is_consistent == 2) {
              // 渐变色
              if (
                item.lens.polarized_light_transparency &&
                item.lens.polarized_light_transparency != 0
              ) {
                return true;
              }
              return false;
            } else {
              return true;
            }
          }
          return false;
        }
        return false;
      } catch (error) {
        console.error(error);
      }
      return false;
    },
    handleIsDisabled(item) {
      if (item.type == 3 && item.cart_id !== this.cartPrice?.default_gift_cart_id) {
        item.disabled = true;
        item.selected = false;
      } else if (item.type == 3 && item.cart_id == this.cartPrice?.default_gift_cart_id) {
        item.disabled = false;
        item.selected = true;
      }
      return item;
    },
    totalClipPriceInfo,
    getShowIfPrice(valuationList, item) {
      return Number(
        Number(valuationList.product_payable) +
          Number(valuationList.product_point_discounts_price) +
          Number(valuationList.product_code_discounts_price) +
          Number(this.totalClipPriceInfo(item.clips, this.currency.name).sell_price),
      ).toFixed(2);
    },
    getLineThroughIf(valuationList, item) {
      return (
        +item.is_gift_buy_activity_product === 1 ||
        (item.selected &&
          valuationList.half_qty &&
          Number(valuationList.base_product_rule_discounts_price) > 0) ||
        (item.selected && valuationList && valuationList.gift_type == 2)
      );
    },
    getLineThroughElse(item) {
      return item.gift_type == 1 || (item.gift_type != 1 && item.type == 3);
    },
    getLineThroughIfPrice(valuationList, item) {
      return Number(
        Number(valuationList.discount_birthday) +
          Number(valuationList.product_payable_no_half) +
          Number(this.totalClipPriceInfo(item.clips, this.currency.name).sell_price),
      ).toFixed(2);
    },
    getLineThroughElsePrice(item) {
      return Number(this.$priceUtil.genPrice(item.product.price_info).price).toFixed(2);
    },
    hasDiscountPrice(item) {
      const normalPrice = (
        Number(item.discount_birthday) +
        Number(item.product_payable) +
        Number(item.product_rule_discounts_price) +
        Number(totalClipPriceInfo(item.clips, this.currency.name).sell_price)
      ).toFixed(2);
      const discountPrice = (
        Number(item.product_payable) +
        Number(totalClipPriceInfo(item.clips, this.currency.name).sell_price)
      ).toFixed(2);
      return normalPrice > discountPrice;
    },
    cartAllPrice(index) {
      if (+this.item?.valuationItem?.product_rule_discounts_price > 0) {
        return (
          Number(this.valuationList[index].discount_birthday) +
          Number(this.valuationList[index].product_payable) +
          Number(this.valuationList[index].product_rule_discounts_price)
        ).toFixed(2);
      } else {
        return (
          Number(this.valuationList[index].discount_birthday) +
          Number(this.valuationList[index].product_payable) +
          Number(this.valuationList[index].product_rule_discounts_price) +
          Number(totalClipPriceInfo(this?.item?.clips, this.currency.name).sell_price)
        ).toFixed(2);
      }
    },
    // 获取勾选商品的计价信息
    async getCartPrice() {
      try {
        // 赠品商品的勾选由接口处理（default_cart=1），前端传 cart_ids 不需要包含赠品
        const noFreeGiftList = this.cartInforCopy.list?.filter((item) => item.type != 3) || [];
        const cart_ids = getCartIds(noFreeGiftList);
        if (cart_ids?.length === 0) {
          this.cartPrice = {
            total: '0.00',
            discount: '0.00',
            subtotal: '0.00',
            price: {
              discount: '0.00',
              total: '0.00',
              subtotal: '0.00',
            },
          };
          this.valuationList = [];
          return;
        }
        const { data } = await this.$api.cart.getCartPrice({
          currency: this.currency.name,
          cart_ids,
          apply_discount: 1,
          is_display_wap_ab: 1,
          default_cart: 1,
        });
        this.cartPrice = data;
        const cartPriceList = data.tmp.carts;

        this.outSetProFunc(cartPriceList);

        // Ps: 写成计算属性在首次落地时会失效。在这里处理是最合适的地方。
        this.hasFreeGiftSelected = false;
        cartPriceList.forEach((_priceItem) => {
          if (_priceItem.type == 3 && _priceItem.id == data.default_gift_cart_id) {
            this.hasFreeGiftSelected = true;
          }
        });

        if (data.free_shipping_policy) {
          this.handleFreePolicy(data.free_shipping_policy);
        } else {
          this.resetFreePolicy();
        }
      } catch (error) {
        console.log(error);
      }
    },
    handleFreePolicy(policy = {}) {
      try {
        this.freeShippingStatus = policy.freeshipping_status;
        //  文案保持与wap端一致
        if (!policy.copywriting) {
          this.freePolicy = '';
        } else if (policy.copywriting.indexOf('{free_threshold}') != -1) {
          this.freePolicy = policy.copywriting.replace(
            '{free_threshold}',
            `<span class="notranslate"> ${policy.symbol_prefix}${policy.free_threshold}${policy.symbol_suffix} </span>`,
          );
        } else {
          this.freePolicy = policy.copywriting;
        }
      } catch (error) {
        console.error(error);
      }
    },
    resetFreePolicy() {
      this.freePolicy = '';
      this.freeShippingStatus = false;
    },
    outSetProFunc(cartPriceList) {
      if (cartPriceList.length > 0) {
        // 因为在悬浮窗里的计价相当于是购物车里面全选的计价，所以可以不用对比，直接赋值
        this.cartInforCopy.list.forEach((item, index) => {
          this.valuationList[index] = null;
          cartPriceList.forEach((item2) => {
            if (item.cart_id == item2.id) {
              // 向购物车存储计价数据
              this.valuationList[index] = item2;
            }
          });
          // 把接口返回的夹片价格整合到购物车列表的夹片项里
          setClipValuation(item.clips, cartPriceList);
        });
      } else {
        this.valuationList = [];
      }
    },
    toCart() {
      if (this.$route.name != 'cart') {
        sessionStorage.setItem('Cart_View--entrance_cart_scene', '购物车弹窗');
      }
      this.$router.push('/cart');
      this.$emit('update:toshowCart', false);
      this.SD_CartPopUpBtn_Click({ btn_name: 'View My Cart' });
    },
    toPayment() {
      if (this.token) {
        this.checkCart();
      } else {
        this.$emit('visitorToPayment');
      }
      this.SD_CartPopUpBtn_Click({ btn_name: 'Proceed to Checkout' });
    },
    async checkCart() {
      try {
        this.loading.check = true;
        const params = this.buildCheckCartParams();
        if (!params.cart_ids?.length) {
          this.$router.push('/cart');
          return;
        }
        const res = await this.$api.cart.check(params);

        if (res.data.code) {
          setSession('header_cart_check_error', res.data);
          this.$router.push('/cart');
        } else {
          this.preparePaymentSession(res.data, params);
          this.$router.push('/payment');
        }
      } catch (error) {
        console.log(error);
        // 443: 1. 前端计算的总价与最新的总价不一致; 2. 优惠项不可用;
        if (error?.code === 443 && error?.msg) {
          this.$message.error(error.msg);
        }
        this.$router.push('/cart');
      } finally {
        this.loading.check = false;
      }
    },
    buildCheckCartParams() {
      let usedCoupon = '';
      try {
        if (this.cartPrice.coupon?.type === 2) {
          usedCoupon = this.cartPrice.coupon.id;
        }
      } catch (error) {
        console.log(error);
      }
      // check 接口不支持 default_cart:1 前端传 cart_ids 需要包含赠品
      const noFreeGiftList = this.cartInforCopy.list?.filter((item) => item.type != 3) || [];
      const cart_ids = getCartIds(noFreeGiftList);
      if (this.cartPrice?.default_gift_cart_id) {
        cart_ids.push(this.cartPrice?.default_gift_cart_id);
      }
      return {
        cart_ids,
        currency: this.currency.name,
        apply_discount: 2,
        point: this.cartPrice.price.is_point,
        coupon: usedCoupon,
        code: '',
        price: {
          total: this.cartPrice.price?.total,
        },
      };
    },
    // 准备支付页面所需的会话数据
    preparePaymentSession(cartPrice = {}, params = {}) {
      this.cartInfor.list.forEach((item) => {
        item.selected = params.cart_ids?.includes(item.cart_id);
      });
      this.SET_CARTINFOR(this.cartInfor);
      sessionStorage.setItem('PlaceOrderPage_View--entrance_payment_scene', '头部购物车悬浮弹层');
      sessionStorage.setItem('isNewFlow', '1');

      // 清除旧的会话数据
      ['isNewFlow-usedCode', 'isNewFlow-usedCoupon', 'isNewFlow-couponInfo'].forEach((key) => {
        sessionStorage.removeItem(key);
      });

      // 设置新的会话数据
      let usedCode = '';
      try {
        if (cartPrice.coupon?.model_type === 1 || cartPrice.coupon?.type === 1) {
          usedCode = cartPrice.coupon.code;
        }
      } catch (error) {
        console.log(error);
      }
      let usedCoupon = '';
      try {
        if (cartPrice.coupon?.type === 2) {
          usedCoupon = cartPrice.coupon.id;
        }
      } catch (error) {
        console.log(error);
      }
      if (usedCode) {
        sessionStorage.setItem('isNewFlow-usedCode', usedCode);
      } else if (usedCoupon) {
        sessionStorage.setItem('isNewFlow-usedCoupon', usedCoupon);
      }

      const pointInfo = cartPrice.price?.is_point || 0;
      sessionStorage.setItem('isNewFlow-pointInfo', pointInfo);
    },
    /**
     * @EventDesc 购物车弹窗点击
     */
    SD_CartPopUpBtn_Click({ btn_name } = {}) {
      try {
        const sdEventName = 'CartPopUpBtn_Click';
        const sdEventParams = {
          url_path: location.href,
          page_name: this.$route.meta.cnName,
          btn_name,
        };
        window.voo_sensors.sensorsTrack(sdEventName, sdEventParams);
      } catch (e) {
        console.log(e);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.cart-box {
  position: relative;
  height: 100%;

  @include flex(flex-end, $dir: column);
  .cart-list {
    flex: 1;
    overflow-y: auto;
    padding-top: 24px;
    padding-bottom: 12px;
    box-sizing: border-box;
    li {
      position: relative;
      margin: 0 48px 16px;
      padding: 16px;
      min-height: 168px;
      border-radius: 10px;
      background: #ffffff;
      box-sizing: border-box;

      @include flex(normal);
      &.gift-select {
        &::after {
          content: '';
          position: absolute;
          left: 0;
          top: 0;
          width: 100%;
          height: 100%;
          background: rgba(255, 255, 255, 0.5);
        }
      }
      .img-wrap {
        @include flex(center, center);

        width: 136px;
        height: 136px;
        border-radius: 4px;
        background-color: #f2f2f2;
        box-sizing: border-box;
        & > div {
          width: 136px;
        }
        .frame-img-wrap {
          mix-blend-mode: multiply;
          &.product-gray {
            mix-blend-mode: normal;
          }
          .cart-box .cart-list li .img-wrap > div {
            width: 100%;
          }
        }
      }
      .is-glass {
        padding: 0 12px;
      }
      .cart-info {
        @include flex(space-between, normal, $dir: column);

        margin-top: 3px;
        margin-left: 30px;
        width: 330px;
        font-size: 16px;
        .name,
        .color,
        .pres,
        .qty-price {
          line-height: 26px;
        }
        .name {
          display: flex;
          justify-content: flex-start;
          align-items: center;
          margin-bottom: 10px;
          width: 290px;
          font-size: 18px;
          color: #080506;
          flex-direction: row;
          .name-word {
            @include ellipsis;
          }
        }
        .color {
          margin-bottom: 8px;
          color: #5a544e;
          span {
            margin-left: 8px;
          }
        }
        .pres {
          margin-bottom: 8px;
          color: #5a544e;
        }
        .qty-price-box {
          @include flex(space-between, center);
        }
        .qty-price {
          color: #5a544e;
          span {
            margin-left: 3px;
          }
        }
        .text-box {
          margin-top: 14px;
        }
        .text {
          line-height: 20px;
          font-size: 14px;
          font-family: $f-lr;
          color: #ff2020;
        }
        .goods-price-box {
          @include flex(normal, center, $wrap: wrap);

          flex-direction: row-reverse;
          font-size: 16px;
          span {
            font-size: 16px;
            &:first-child {
              font-family: $f-pr;
            }
          }
          .through-line-price {
            text-decoration: line-through;
            white-space: nowrap;
            font-size: 16px;
            font-family: $f-pr;
            color: #908b7f;
          }
          .show-price {
            margin-left: 10px;
            white-space: nowrap;
          }
          .base-color {
            color: $origin;
          }
        }
      }
    }
  }
  .bottom-wrap {
    // position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.3);
  }
  .deliver {
    position: relative;
    z-index: 20;
    width: 100%;
    height: 40px;
    line-height: 40px;
    text-align: center;
    font-size: 14px;
    color: #080506;
    background: #fef5ec;
    .word-policy {
      font-family: $f-lr;
      color: #c23000;
      :deep(span) {
        color: #c23000;
      }
    }
  }
  .bottom-price {
    padding: 0 48px 32px;
    background-color: #ffffff;
    box-sizing: border-box;
    p {
      @include flex(space-between, center);

      padding-bottom: 16px;
      span {
        line-height: 22px;
        font-size: 16px;
      }
      .special-off {
        color: $origin;
      }
      .special-money {
        font-size: 24px;
        font-family: $f-pb;
      }
    }
    .point-tip {
      cursor: pointer;
      font-size: 14px;
    }
    .gray {
      color: #5a544e;
    }
    .btn-box {
      @include flex(space-between, center);
      .el-button {
        height: 48px;
        border-radius: 4px;
        font-size: 16px;
        font-family: $f-psb;
        &:nth-child(1) {
          border: 1px solid #271717;
        }
        &:nth-child(2) {
          margin-left: 24px;
        }
      }
    }
    .total-box {
      padding-top: 16px;
      border-bottom: 1px solid #e3e1de;
    }
    .subtotal-box {
      @include flex(space-between, center);

      padding-top: 17px;
      padding-bottom: 24px;
      .subtotal-name {
        font-size: 16px;
        font-family: $f-pb;
      }
      p {
        padding-bottom: 0;
      }
      .all-saved {
        @include flex(center, center);

        margin-right: 8px;
        padding: 0 12px;
        height: 32px;
        line-height: 32px;
        border-radius: 16px;
        font-size: 14px;
        color: $origin;
        background: #fef5ec;
        cursor: pointer;
        i {
          display: inline-block;
          margin-left: 5px;
          font-size: 20px;
          transition: transform 0.3s ease-in-out;
          transform: rotate(-90deg);
          &.rotate {
            transform: rotate(90deg);
          }
        }
      }
    }
  }
}
.view_my_cart {
  border: 1px solid #271717;
  border-radius: 4px;
  font-size: 16px;
  font-family: $f-psb;
  color: #1a1c1e;
  background: #ffffff;
}
</style>
